export const countSelectedFiles = (files = []) => {
  let selectedFilesNum = 0;
  for (const file of files) {
    if (file.children && file.children.length) {
      selectedFilesNum += countSelectedFiles(file.children);
    } else if (file.selected) {
      selectedFilesNum++;
    }
  }
  return selectedFilesNum;
};



// WEBPACK FOOTER //
// ./src/state/project/selectors.js